import * as PropTypes from 'prop-types';

const InstitutionConstants = {
  PropTypes: {
    institution: PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      shortName: PropTypes.string.isRequired,
      names: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      verified: PropTypes.bool.isRequired,
      urlIdentifier: PropTypes.string,
      licensed: PropTypes.bool.isRequired,
    }),
  },
  USER_SUPPLIED_ID_PREFIX: 'inst_user:',
};

export interface Institution {
  id: string;
  name: string;
  fullName: string;
  shortName: string;
  names: Array<string>;
  subdomains: Array<string>;
  urlIdentifier?: string;
  verified: boolean;
  licensed: boolean;
  hasUnlimitedSpace: boolean;
  grantsElnDesktopSync: boolean;
  adminEmail?: string;
  enableExportNotifications: boolean;
  enableEmailChangeNotifications: boolean;
}

export default InstitutionConstants;
